module.exports = "<div id=\"popup-overlay\" [class.active]=\"popupService.active\">\n    <ng-container *ngComponentOutlet=\"popupService.type\"></ng-container>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/popup/popup.component.html
// module id = 467
// module chunks = 0